import { Select } from 'antd';

const CustomSelect = ({
  Form,
  data,
  rules,
  parentKey,
  onSelect,
  renderOptions,
  selectcontriyName,
  handleTracking,
  ...rest
}) => {
  return (
    <Form.Item
      name={[parentKey, data.name]}
      label={data.title}
      rules={rules?.[data?.name]}
      onBlur={data.onBlurTrack ? handleTracking : () => {}} 
    >
      {data.customRender ? (
        <Select
          allowClear
          style={{
            width: '100%'
          }}
          optionFilterProp={"label"}
          disabled={data?.disabled}
          showArrow={false}
          showSearch={true}
          onSelect={(e) =>
            data.courseSelection ? onSelect(e, data) : () => {}
          }
          {...rest}
        >
          {renderOptions(data.optionKey)}
        </Select>
      ) : (
        <Select
          allowClear
          optionFilterProp={"label"}
          showSearch={true}
          style={{
            width: '100%'
          }}
          options={data.options}
          {...rest}
          onChange={data.onBlurTrack ?  (e)=>selectcontriyName(e) : () => {}}
        />
      )}
    </Form.Item>
  );
};

export default CustomSelect;
